export const CONST = {
  HEADER: $localize`Clear Security Screening`,
  END: $localize`End`,
  NEW: $localize`New Screening`,
  SEARCH: $localize`Search`,
};
export enum ColumnIds {
  TRACKING_NUMBER = 'trackingNumber',
  SCREENING_TYPE = 'screeningType',
  SCREENING_METHOD = 'screeningMethod',
  SCREENER_ID = 'screenerID',
  SECONDARY_SCREENING = 'secondaryScreening',
}

export const ColumnText = {
  TRACKING_NUMBER: $localize`Tracking Number`.toUpperCase(),
  SCREENING_TYPE: $localize`Screening Type`.toUpperCase(),
  SCREENING_METHOD: $localize`Screening Method`.toUpperCase(),
  SCREENER_ID: $localize`Screener ID`.toUpperCase(),
  SECONDARY_SCREENING: $localize`Secondary Screening`.toUpperCase(),
};

export const EXCEL_FILE_NAME = $localize`clear-security-screening`;

export interface ClearSecurityScreening {
  trackingNumber: string;
  screeningType: string;
  screeningMethod: string;
  screenerID: string;
  secondaryScreening: boolean;
}

export const MOCK_TABLE_CONSTS: ClearSecurityScreening[] = [
  {
    trackingNumber: '1Z1801890120203947',
    screeningType: 'SCR1',
    screeningMethod: 'XR3 : MANUAL X-RAY',
    screenerID: 'DDPPM',
    secondaryScreening: true,
  },
  {
    trackingNumber: '1Z1801890120203948',
    screeningType: 'SCR2',
    screeningMethod: 'XR2 : TIMES X-RAY',
    screenerID: 'DDPPN',
    secondaryScreening: true,
  },
  {
    trackingNumber: '1Z1801890120203953',
    screeningType: 'SCR2',
    screeningMethod: 'AOM: ANY OTHER MEANS',
    screenerID: 'DDPPN',
    secondaryScreening: false,
  },
  {
    trackingNumber: '1Z1801890120203952',
    screeningType: 'SCR1',
    screeningMethod: 'EDD : EXPLOS DET DOGS',
    screenerID: 'DDPPN',
    secondaryScreening: false,
  },
  {
    trackingNumber: '1Z1801890120203952',
    screeningType: 'Comm Verif',
    screeningMethod: 'LFS : LIFESAVINGMATRL',
    screenerID: 'DDPPN',
    secondaryScreening: true,
  },
  {
    trackingNumber: '1Z1801890120203963',
    screeningType: 'Comm Verif',

    screeningMethod: 'IAC : INDIRECT AIR CARRIER',
    screenerID: 'DDPPN',
    secondaryScreening: true,
  },
  {
    trackingNumber: '1Z1801890120203968',
    screeningType: 'SCR1',

    screeningMethod: 'EDD : EXPLOS DET DOGS',
    screenerID: 'DDPPN',
    secondaryScreening: true,
  },
  {
    trackingNumber: '1Z1801890120203988',
    screeningType: 'SCR2',

    screeningMethod: 'IAC : INDIRECT AIR CARRIER',
    screenerID: 'DDPPN',
    secondaryScreening: true,
  },
  {
    trackingNumber: '1Z1801890120203968',
    screeningType: 'Comm Verif',

    screeningMethod: 'LFS : LIFESAVINGMATRL',
    screenerID: 'DDPPN',
    secondaryScreening: false,
  },
  {
    trackingNumber: '1Z1801890120203954',
    screeningType: 'Comm Verif',

    screeningMethod: 'TRN : TRANSSHIPMENT',
    screenerID: 'DDPPN',
    secondaryScreening: false,
  },
  {
    trackingNumber: '1Z1801890120203954',
    screeningType: 'Comm Verif',

    screeningMethod: 'XR3 : MANUAL X-RAU',
    screenerID: 'DDPPN',
    secondaryScreening: true,
  },
  {
    trackingNumber: '1Z1801890120203966',
    screeningType: 'Comm Verif',

    screeningMethod: 'ETD : EXPLOSIVE TRACE',
    screenerID: 'DDPPM',
    secondaryScreening: true,
  },
  {
    trackingNumber: '1Z1801890120203962',
    screeningType: 'SCR2',

    screeningMethod: 'PHS : HAND SEARCH',
    screenerID: 'DDPPM',
    secondaryScreening: true,
  },
  {
    trackingNumber: '1Z1801890120203954',
    screeningType: 'SCR1',

    screeningMethod: 'TRN : TRANSSHIPMENT',
    screenerID: 'DDPPN',
    secondaryScreening: false,
  },
];
